import {_RequestEnvelope} from '../core/types';
import {
    ProductBaseArt,
    ProductBaseArtPropertyInput,
    ProductFinalizedArt,
    ProductFinalizedArtPropertyInput,
} from '../models/productasset';

// ---------------------------------------------------------------------------
// AddProductFinalizedArt
// ---------------------------------------------------------------------------

export interface AddProductFinalizedArtRequest {
    SiteTemplateId: string;
    ProductType: string;
    ProductId: string;
    Properties: ProductFinalizedArtPropertyInput[];
}

export const AddProductFinalizedArtResultCode = {
    Unknown: 'Unknown',
    Ok: 'Ok',
    SiteTemplateNotFound: 'SiteTemplateNotFound',
} as const;
export type AddProductFinalizedArtResult =
    typeof AddProductFinalizedArtResultCode[keyof typeof AddProductFinalizedArtResultCode];

export type AddProductFinalizedArtResponse =
    | {
    Result: 'Ok';
    ResultDescription: string;
    FinalizedArt: ProductFinalizedArt;
}
    | {
    Result: 'Unknown' | 'SiteTemplateNotFound';
    ResultDescription: string;
    FinalizedArt: null;
};

const _addProductFinalizedArtMap: Record<number, string> = {
    0: 'Unknown',
    1: 'Ok',
    2: 'SiteTemplateNotFound',
};

export function addProductFinalizedArt(
    params: AddProductFinalizedArtRequest
): _RequestEnvelope<AddProductFinalizedArtResponse> {
    return {...params, _endpoint: 'admin/productAsset/addProductFinalizedArt', _resultCodeMap: _addProductFinalizedArtMap};
}

// ---------------------------------------------------------------------------
// DeleteProductFinalizedArt
// ---------------------------------------------------------------------------

export interface DeleteProductFinalizedArtRequest {
    Id: string;
}

export const DeleteProductFinalizedArtResultCode = {
    Unknown: 'Unknown',
    Ok: 'Ok',
    NotFound: 'NotFound',
} as const;
export type DeleteProductFinalizedArtResult =
    typeof DeleteProductFinalizedArtResultCode[keyof typeof DeleteProductFinalizedArtResultCode];

export type DeleteProductFinalizedArtResponse =
    {
        Result: DeleteProductFinalizedArtResult;
    ResultDescription: string;
};

const _deleteProductFinalizedArtMap: Record<number, string> = {
    0: 'Unknown',
    1: 'Ok',
    2: 'NotFound',
};

export function deleteProductFinalizedArt(
    params: DeleteProductFinalizedArtRequest
): _RequestEnvelope<DeleteProductFinalizedArtResponse> {
    return {...params, _endpoint: 'admin/productAsset/deleteProductFinalizedArt', _resultCodeMap: _deleteProductFinalizedArtMap};
}

// ---------------------------------------------------------------------------
// ListProductBaseArt
// ---------------------------------------------------------------------------

export interface ListProductBaseArtRequest {
    SiteTemplateId: string | null;
    ProductType: string | null;
    ProductId: string | null;
}

export interface ListProductBaseArtResponse {
    Items: ProductBaseArt[];
}

export function listProductBaseArt(params: ListProductBaseArtRequest): _RequestEnvelope<ListProductBaseArtResponse> {
    return {...params, _endpoint: 'admin/productAsset/listProductBaseArt', _resultCodeMap: null};
}

// ---------------------------------------------------------------------------
// ListProductFinalizedArt
// ---------------------------------------------------------------------------

export interface ListProductFinalizedArtRequest {
    SiteTemplateId: string | null;
    ProductType: string | null;
    ProductId: string | null;
}

export interface ListProductFinalizedArtResponse {
    Items: ProductFinalizedArt[];
}

export function listProductFinalizedArt(params: ListProductFinalizedArtRequest): _RequestEnvelope<ListProductFinalizedArtResponse> {
    return {...params, _endpoint: 'admin/productAsset/listProductFinalizedArt', _resultCodeMap: null};
}

// ---------------------------------------------------------------------------
// SetProductBaseArt
// ---------------------------------------------------------------------------

export interface SetProductBaseArtRequest {
    SiteTemplateId: string;
    ProductType: string;
    ProductId: string;
    Properties: ProductBaseArtPropertyInput[];
}

export const SetProductBaseArtResultCode = {
    Unknown: 'Unknown',
    Ok: 'Ok',
    SiteTemplateNotFound: 'SiteTemplateNotFound',
} as const;
export type SetProductBaseArtResult =
    typeof SetProductBaseArtResultCode[keyof typeof SetProductBaseArtResultCode];

export type SetProductBaseArtResponse =
    | {
    Result: 'Ok';
    ResultDescription: string;
    BaseArt: ProductBaseArt;
}
    | {
    Result: 'Unknown' | 'SiteTemplateNotFound';
    ResultDescription: string;
    BaseArt: null;
};

const _setProductBaseArtMap: Record<number, string> = {
    0: 'Unknown',
    1: 'Ok',
    2: 'SiteTemplateNotFound',
};

export function setProductBaseArt(
    params: SetProductBaseArtRequest
): _RequestEnvelope<SetProductBaseArtResponse> {
    return {...params, _endpoint: 'admin/productAsset/setProductBaseArt', _resultCodeMap: _setProductBaseArtMap};
}

// ---------------------------------------------------------------------------
// UpdateProductBaseArt
// ---------------------------------------------------------------------------

export interface UpdateProductBaseArtRequest {
    SiteTemplateId: string;
    ProductType: string;
    ProductId: string;
    SetProperties: ProductBaseArtPropertyInput[];
    RemoveNames: string[];
}

export const UpdateProductBaseArtResultCode = {
    Unknown: 'Unknown',
    Ok: 'Ok',
    SiteTemplateNotFound: 'SiteTemplateNotFound',
} as const;
export type UpdateProductBaseArtResult =
    typeof UpdateProductBaseArtResultCode[keyof typeof UpdateProductBaseArtResultCode];

export type UpdateProductBaseArtResponse =
    | {
    Result: 'Ok';
    ResultDescription: string;
    BaseArt: ProductBaseArt;
}
    | {
    Result: 'Unknown' | 'SiteTemplateNotFound';
    ResultDescription: string;
    BaseArt: null;
};

const _updateProductBaseArtMap: Record<number, string> = {
    0: 'Unknown',
    1: 'Ok',
    2: 'SiteTemplateNotFound',
};

export function updateProductBaseArt(
    params: UpdateProductBaseArtRequest
): _RequestEnvelope<UpdateProductBaseArtResponse> {
    return {...params, _endpoint: 'admin/productAsset/updateProductBaseArt', _resultCodeMap: _updateProductBaseArtMap};
}
